import React, { useState, useEffect } from 'react';
import './SaveFlowModal.css';

const API_BASE = 'http://10.0.9.7:3001';

const SaveFlowModal = ({ isOpen, onClose, onSave, currentUserId }) => {
    const [saveType, setSaveType] = useState('self'); // 'default', 'organisation', 'self'
    const [organisations, setOrganisations] = useState([]);
    const [selectedOrgId, setSelectedOrgId] = useState('');
    const [overwrite, setOverwrite] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setLoading(true);
            fetch(`${API_BASE}/api/organisations`)
                .then(res => res.json())
                .then(data => {
                    setOrganisations(data);
                    if (data.length > 0) {
                        setSelectedOrgId(data[0].id);
                    }
                    setLoading(false);
                })
                .catch(err => {
                    console.error('Failed to fetch organisations:', err);
                    setLoading(false);
                });
        }
    }, [isOpen]);

    if (!isOpen) return null;

    const handleSave = (forceOverwrite = false) => {
        let flow_active = 0;
        let target_user_id = currentUserId;

        if (saveType === 'default') {
            flow_active = 2;
        } else if (saveType === 'organisation') {
            flow_active = 1;
            target_user_id = selectedOrgId;
        } else {
            flow_active = 0;
        }

        onSave({ flow_active, target_user_id, overwrite: forceOverwrite || overwrite });
        onClose();
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content save-flow-modal">
                <h3>Save Flow</h3>
                <div className="save-options">
                    <div className="option">
                        <input
                            type="radio"
                            id="save-default"
                            name="saveType"
                            value="default"
                            checked={saveType === 'default'}
                            onChange={(e) => setSaveType(e.target.value)}
                        />
                        <label htmlFor="save-default">Save as Default Template</label>
                    </div>
                    <div className="option">
                        <input
                            type="radio"
                            id="save-organisation"
                            name="saveType"
                            value="organisation"
                            checked={saveType === 'organisation'}
                            onChange={(e) => setSaveType(e.target.value)}
                        />
                        <label htmlFor="save-organisation">Save for an Organisation</label>
                    </div>
                    {saveType === 'organisation' && (
                        <div className="org-selection">
                            <label htmlFor="org-select">Select Organisation:</label>
                            {loading ? (
                                <span>Loading...</span>
                            ) : (
                                <select
                                    id="org-select"
                                    value={selectedOrgId}
                                    onChange={(e) => setSelectedOrgId(e.target.value)}
                                >
                                    {organisations.map(org => (
                                        <option key={org.id} value={org.id}>
                                            {org.name || `Org ${org.id}`}
                                        </option>
                                    ))}
                                </select>
                            )}
                        </div>
                    )}
                    <div className="option">
                        <input
                            type="radio"
                            id="save-self"
                            name="saveType"
                            value="self"
                            checked={saveType === 'self'}
                            onChange={(e) => setSaveType(e.target.value)}
                        />
                        <label htmlFor="save-self">Save for Self</label>
                    </div>
                    <div className="option overwrite-option" style={{ marginTop: '1rem', paddingTop: '1rem', borderTop: '1px solid #eee' }}>
                        <input
                            type="checkbox"
                            id="overwrite-checkbox"
                            checked={overwrite}
                            onChange={(e) => setOverwrite(e.target.checked)}
                        />
                        <label htmlFor="overwrite-checkbox" style={{ fontWeight: 600, color: '#d32f2f' }}>
                            Overwrite existing flow if name conflicts
                        </label>
                    </div>
                </div>
                <div className="modal-actions">
                    <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
                    <button className="btn btn-primary" onClick={() => handleSave()} disabled={saveType === 'organisation' && !selectedOrgId}>Save</button>
                </div>
            </div>
        </div>
    );
};

export default SaveFlowModal;

